import React from "react";
import { Box, Stack, } from "@mui/system";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { Typography } from "@mui/material";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import { getTranslation } from "common";
import { useTranslations } from "hooks";

interface LabelProps {
    color?: string;
    name?: string;
    onRemove?: () => void;
    onModify?: () => void;
}

export const Label: React.FC<LabelProps> = ({ color, name, onRemove, onModify, }) => {
    const translations = useTranslations();

    return (
        <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
        >
            <Box
                sx={{
                    borderRadius: '4px',
                    height: '35px',
                    width: '200px',
                    backgroundColor: color,
                    overflow: "hidden",
                }}
            >
                <Typography variant="body2" sx={{ padding: "0px 8px", lineHeight: "35px", textAlign: "center", color: (_) => _.palette.getContrastText(color || "") }}>
                    {name || getTranslation(translations, "generic.labelname.caption")}
                </Typography>
            </Box>
            <DeleteForeverRoundedIcon
                sx={{
                    cursor: "pointer",
                    color: _ => _.palette.grey[600],
                    ml: 2,
                }}
                onClick={onRemove}
            />
            <EditRoundedIcon
                sx={{
                    cursor: "pointer",
                    color: _ => _.palette.grey[600],
                    ml: 2,
                }}
                onClick={onModify}
            />
        </Stack>
    );
}
